import React from 'react';
import { Text } from 'src/modules/shared/components/atoms/text';
import { classes } from 'src/modules/shared/utils/styles.util';

/** Props for the heading at the top of a settings section. */
interface SectionHeadingProps {
  /** Section title. */
  title: string;
  /** Short explanation of the section, when it needs one. */
  description?: string;
  /** Extra classes for the wrapper. */
  className?: string;
}

/**
 * Title and optional one-line explanation at the top of a settings section,
 * under the page header, as used by the settings pages.
 *
 * @param props - Title, description and optional classes.
 * @returns The section heading.
 */
export const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  description,
  className,
}) => (
  <div className={classes('space-y-1', className)}>
    <Text as="h3" size="h5" weight="medium">
      {title}
    </Text>
    {description ? (
      <Text size="small" color="secondary">
        {description}
      </Text>
    ) : null}
  </div>
);
